import React from 'react';
import Radium from 'radium';
import { string, func, bool, shape, any } from 'prop-types';
import { shouldShowErrors } from '@widergy/web-utils/lib/form';
import { UTLabel } from '@widergy/energy-ui';

import styles from './styles';

function UTSelectInput({
  input,
  onChangeText,
  style,
  disabled,
  multiple,
  options,
  keyProp,
  labelKey,
  valueKey,
  withOrder,
  placeholder,
  meta
}) {
  const wrapOnChange = val => input.onChange(onChangeText(val));

  let sortedOptions = [...options];
  sortedOptions = withOrder ? sortedOptions.sort((a, b) => (a.order < b.order ? -1 : 1)) : sortedOptions;
  return (
    <div style={[styles.container, style]}>
      <div style={styles.textInputWrapper}>
        <div style={styles.placeholder}>
          {(meta.active || input.value) && (
            <UTLabel small darkGray={!meta.active} primary={meta.active}>
              {placeholder}
            </UTLabel>
          )}
        </div>
        <select
          name={input.name}
          disabled={disabled}
          multiple={multiple}
          onChange={wrapOnChange}
          onBlur={input.onBlur}
          onFocus={input.onFocus}
          value={input.value}
          style={[styles.input, !input.value && styles.inputPlaceholder]}
        >
          {placeholder && (
            <option value="" disabled selected hidden>
              {placeholder}
            </option>
          )}
          {sortedOptions.map(option => (
            <option key={option[keyProp]} value={option[valueKey]}>
              {option[labelKey]}
            </option>
          ))}
        </select>
      </div>
      {shouldShowErrors(meta) && (
        <div style={styles.errorsContainer}>
          <UTLabel small error>
            {meta.error}
          </UTLabel>
        </div>
      )}
    </div>
  );
}

UTSelectInput.defaultProps = {
  onChangeText: val => val
};

UTSelectInput.propTypes = {
  placeholder: string,
  input: shape({
    name: string.isRequired,
    onBlur: func.isRequired,
    onChange: func.isRequired,
    onFocus: func.isRequired,
    value: any.isRequired
  }).isRequired,
  meta: shape({
    active: bool.isRequired,
    error: string,
    invalid: bool.isRequired,
    pristine: bool.isRequired,
    visited: bool.isRequired,
    submitFailed: bool
  }).isRequired,
  onChangeText: func,
  options: any, // eslint-disable-line react/forbid-prop-types
  multiple: bool,
  disabled: bool,
  withOrder: bool,
  keyProp: string,
  valueKey: string,
  labelKey: string
};

export default Radium(UTSelectInput);
